import axios, { AxiosResponse } from 'axios';
import ApiException from '@/services/ApiException';
import config from "@/app.config.json";

const urlBase = `${config.urlApi}`

const urls = {
    obter: `${urlBase}/Boletos/ObterGrid`,
    obterPorId: `${urlBase}/Boletos`,
    adicionar: `${urlBase}/Boletos`,
    alterar: `${urlBase}/Boletos`,
    excluir: `${urlBase}/Boletos`,
    obterOpcoes: `${urlBase}/Boletos/ObterOpcoes`,
    obterAcoes: `${urlBase}/Boletos/ObterAcoes`,

    gerarBoletos: `${urlBase}/Boletos/GerarBoletos`,
    verBoleto: `${urlBase}/Boletos/VerBoleto`,
    consultarNoBanco: `${urlBase}/Boletos/ConsultarNoBanco`,

    gerarRemessa: `${urlBase}/Boletos/GerarRemessa`,
    baixarRemessa: `${urlBase}/Boletos/BaixarRemessa`,
    obterRemessas: `${urlBase}/Boletos/ObterRemessas`,
    obterRemessa: `${urlBase}/Boletos/ObterRemessa`,
    obterRemessaItens: `${urlBase}/Boletos/ObterRemessaItens`,
    obterRemessasOcorridas: `${urlBase}/Boletos/ObterRemessasOcorridas`,

    novaOcorrencia: `${urlBase}/Boletos/NovaOcorrencia`,
    cancelarBoleto: `${urlBase}/Boletos/CancelarBoleto`,
    alterarVencimentos: `${urlBase}/Boletos/AlterarVencimentos`,

    importarRetorno: `${urlBase}/Boletos/ImportarRetorno`,
    obterRetornoDetalhes: `${urlBase}/Boletos/ObterRetornoDetalhes`,
    obterRetornoResumo: `${urlBase}/Boletos/ObterRetornoResumo`,
    obterRetornos: `${urlBase}/Boletos/ObterRetornos`,
    processarRetorno: `${urlBase}/Boletos/ProcessarRetorno`,
    obterRetornoDiferencas: `${urlBase}/Boletos/ObterRetornoDiferencas`,

    obterRetornosOcorridos: `${urlBase}/Boletos/ObterRetornosOcorridos`,

    importarRelBanco: `${urlBase}/Boletos/ImportarRelatorioBanco`,
    aplicarRelBanco: `${urlBase}/Boletos/AplicarRelatorioBanco`,
    atualizarPixBoletos: `${urlBase}/Boletos/AtualizarPixBoletos`,
}

function getToken(): string {

    const x = localStorage.getItem('user');

    if (x != null) {
        const user = JSON.parse(x);

        if (user && user.accessToken) {
            return `Bearer  ${user.accessToken}`;
        } else {
            return "";
        }
    }
    else
        return "";
}

//#region + Boletos

export const obter = (params?: BoletoFiltros | null | any): Promise<IBoletosGridRetorno> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(urls.obter, params)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao obter boletos"));
            });
    })
};

export const obterPorId = (id: number): Promise<Boleto> => {
    return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization = getToken();

        axios
            .get(urls.adicionar + `/${id}`)
            .then((r) => {
                return resolve(r.data);
            })
            .catch((error) => {
                return reject(new ApiException(error || "Erro ao obter boletos por Id"));
            });
    });
};

export const obterAcoes = (id: number): Promise<BoletoAcaoDTO[]> => {
    return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization = getToken();

        axios
            .get(urls.obterAcoes + `/${id}`)
            .then((r) => {
                return resolve(r.data);
            })
            .catch((error) => {
                return reject(new ApiException(error || "Erro ao obter acoes do boleto"));
            });
    });
};

export const adicionar = (dados: Boleto): Promise<Boleto> => {
    return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization = getToken();

        axios
            .post(urls.adicionar, dados)
            .then((r) => {
                return resolve(r.data);
            })
            .catch((error) => {
                return reject(new ApiException(error || "Erro ao adicionar boleto"));
            });
    });
};

export const alterar = (params: Boleto): Promise<Boleto> => {
    return new Promise((resolve, rejects) => {
        axios.defaults.headers.common.Authorization = getToken();

        axios
            .put(urls.alterar + `/${params.boletoId}`, params)
            .then((r) => {
                return resolve(r.data);
            })
            .catch((error) => {
                return rejects(new ApiException(error || "Erro ao alterar boleto"));
            });
    });
};

export const excluir = (id: number): Promise<Boleto> => {
    return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization = getToken();

        axios
            .delete(urls.excluir + `/${id}`)
            .then((r) => {
                return resolve(r.data);
            })
            .catch((error) => {
                return reject(new ApiException(error || "Erro ao deletar boleto"));
            });
    });
};


export const obterOpcoes = (): Promise<Opcoes> => {
    return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization = getToken();

        axios
            .post(urls.obterOpcoes)
            .then((r) => {
                return resolve(r.data);
            })
            .catch((error) => {
                return reject(new ApiException(error || "Erro ao obter opções"));
            });
    });
};

export const gerarBoletos = (params: GerarBoletoFiltros): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization = getToken();

        axios
            .post(urls.gerarBoletos, params)
            .then((r) => {
                return resolve(r.data);
            })
            .catch((error) => {
                return reject(new ApiException(error || "Erro ao gerar boletos"));
            });
    });
};

export interface GerarBoletoFiltros {
    paramBoletoId: number;
    dataInicial: string;
    dataFinal: string;
    dataVencimento: string;
    nomeUsuario: string;
    senha: string;
}

export const verBoleto = (params?: BoletoFiltros): Promise<any> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(urls.verBoleto, params)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao gerar boletos"));
            });
    })
};

export const consultarNoBanco = (boletoId: number): Promise<StatusBancoGrupoDto[]> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.get(`${urls.consultarNoBanco}/${boletoId}`)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao consultar boleto no banco"));
            });
    })
};

export interface BoletoStatus {
    statusId: number;
    descricao: string;
    ordemExibir: number;
    classeCor: string;
    classeIcone: string;
    podeAlterar: boolean;
    podeRemessa: boolean;
    podeImprimir: boolean;
    podeBaixar: boolean;
    podeProtestar: boolean;
    podeSustarProtesto: boolean;
    podeExcluir: boolean;
}
export interface EnumModel {
    valor: string | null;
    texto: string | null;
    posicao: number | null;
}

export interface Opcoes {
    tiposDescontos: EnumModel[],
    tiposDiasInstrucao: EnumModel[],
    codigosNetativacoes: EnumModel[],
    tiposPessoas: EnumModel[],
    ocorrenciasRemessa: EnumModel[],
    ocorrenciasRetorno: EnumModel[],
    tipoImpressao: EnumModel[],
    carteiraEnvio: EnumModel[],
    status: EnumModel[]
}


export interface BoletoStatus {
    statusId: number;
    descricao: string;
    ordemExibir: number;
    classeCor: string;
    classeIcone: string;
    podeAlterar: boolean;
    podeRemessa: boolean;
    podeImprimir: boolean;
    podeBaixar: boolean;
    podeProtestar: boolean;
    podeSustarProtesto: boolean;
    podeExcluir: boolean;
}

export interface BoletoFiltros {
    empresaId?: number | null;
    paramBoletoId?: number | null;
    boletoId?: number | null;
    nossoNumero?: string;
    nome?: string | null;
    clienteId?: number | null;
    status: BoletoStatus;
    statusIds?: number[] | null;
    ocorrenciasIds?: string[] | null;
    dataVencIni?: string | null;
    dataVencFim?: string | null;
    dataCadIni?: string | null;
    dataCadFim?: string | null;
    dataDocIni?: string | null;
    dataDocFim?: string | null;
    pedidoId?: number | null;
    paginaAtual?: number ;
    tamanhoPagina?: number;
    comUsuarios?: boolean;
}



export interface Boleto {
    boletoId: number;
    empresaId: number | null;
    paramBoletoId: number;
    banco: string | null;
    agencia: string | null;
    posto: string | null;
    conta: string | null;
    codigoGeracao: string;
    numeroDocumento: string;
    parcela: number;
    totalParcelas: number;
    nossoNumero: string;
    carteira: string;
    valorDocumento: number;
    dataVencimento: string | null;
    dataDocumento: string | null;
    dataProcessamento: string | null;
    dataAbatimento: string | null;
    valorAbatimento: number;
    dataDesconto: string | null;
    tipoDesconto: object;
    vlrDesconto: number;
    codigoMora: string;
    valorMoraJuros: number;
    dataMoraJuros: string | null;
    valorIOF: number;
    valorOutrasDespesas: number;
    dataMulta: string | null;
    valorMultaFixo: boolean;
    percMulta: number;
    diasDeProtesto: number;
    dataProtesto: string | null;
    tipoDiasProtesto: object;
    diasDeNegativacao: number | null;
    dataNegativacao: string | null;
    codigoNegativacao: object;
    tipoDiasNegativacao: object;
    dataBaixa: string | null;
    dataLimitePagto: string | null;
    especie: string;
    especieMod: string;
    sacadoNome: string;
    sacadoPessoa: object;
    sacadoCpfCnpj: string;
    sacadoLogradouro: string;
    sacadoNumero: string;
    sacadoBairro: string;
    sacadoComplemento: string | null;
    sacadoCidade: string;
    sacadoUF: string;
    sacadoCep: string;
    sacadoEmail: string | null;
    avalistaNome: string | null;
    avalistaPessoa: object | null;
    avalistaCpfCnpj: string | null;
    avalistaLogradouro: string | null;
    avalistaNumero: string | null;
    avalistaBairro: string | null;
    avalistaComplemento: string | null;
    avalistaCidade: string | null;
    avalistaUF: string | null;
    avalistaCep: string | null;
    avalistaEmail: string | null;
    avalistaInscricaoNr: string | null;
    mensagemLinhas: string | null;
    informativoLinhas: string | null;
    detalhamentoLinhas: string | null;
    instrucao1: string | null;
    instrucao2: string | null;
    aceite: boolean;
    ocorrenciaId: string;
    ocorrencia: BoletoOcorrencia | null;
    seuNumero: string;
    tipoImpressao: object;
    carteiraEnvio: object;
    status: BoletoStatus;
    linhaDigitavel: string | null;
    codigoBarras: string | null;
    clienteId: number | null;
    contratoId?: number | null;
    urlPix?: string | null;
    emv?: string | null;
    pedidoId: number | null;
    paramBoleto: object | null;
    cliente: object | null;
    pedido: object | null;
    modelState: object | null;
    usuCadastro: object | null;
}


export const obterHistorico = (boletoId: number): Promise<BoletoHistoricoDTO[]> => {
    return new Promise((resolve, reject) => {
        axios.defaults.headers.common.Authorization = getToken();

        axios
            .get(`${urlBase}/Boletos/Historico/${boletoId}`)
            .then((r) => {
                return resolve(r.data);
            })
            .catch((error) => {
                return reject(new ApiException(error || "Erro ao obter remessas e retornos do boleto"));
            });
    });
};

export interface BoletoHistoricoDTO {
    tipo: string;
    data: string;
    numero: number;
    arquivo: string | null;
    ocorrenciaId: string | null;
    ocorrencia: string | null;
    valorPago: number | null;
    dataCredito: string | null;
    observacao: string | null;
}

export interface BoletoAcaoDTO {
    id: number;
    data: string;
    usuarioId: number;
    boletoId: number;
    ocorrenciaId: string | null;
    observacoes: string | null;
    ocorrenciaDesc:  string | null;
    usuarioNome:  string | null;
}

export interface IBoletosGridRetorno {
    dados: Array<Boleto>,
    totalRegistros: number
}

export interface StatusBancoGrupoDto {
    titulo: string;
    itens: StatusBancoDTO[];
}

export interface StatusBancoDTO {
    campo: string;
    valor: string;
    classeCor: string;
}
//#region 



//#region + Remessas


export interface BoletoPixResultDTO {
    boletoId: number;
    sucesso: boolean;
    temPix: boolean;
    erro: string | null;
}

export const atualizarPixBoletos = (boletoIds: number[]): Promise<BoletoPixResultDTO[]> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(urls.atualizarPixBoletos, boletoIds, { timeout: 180000 })
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "Falha ao atualizar PIX dos boletos"));
            });
    })
};

export const gerarRemessa = (params?: GerarRemessaDTO | null | any): Promise<BoletoRemessa> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(urls.gerarRemessa, params, { timeout: 180000 })
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao gerar remessa"));
            });
    })
};

export const baixarRemessa = (remessaId: number): Promise<AxiosResponse> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        const params = { remessaId: remessaId };

        axios.get(`${urls.baixarRemessa}/${remessaId}`, { params, responseType: 'blob' })
            .then(r => {
                
                return resolve(r);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao baixar remessa"));
            });
    })
};

export const obterRemessas = (params?: RemessaFiltros | null | any): Promise<IRemessasRetorno> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(urls.obterRemessas, params)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao obter remessas"));
            });
    })
};

export const obterRemessa = (params: BoletoObterRemessaFiltros): Promise<BoletoRemessa> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(urls.obterRemessa, params)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao obter remessa"));
            });
    })
};

export const obterRemessaItens = (params: ObterRemessaItensFiltros): Promise<BoletoRemessaItemDTO[]> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(urls.obterRemessaItens, params)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao obter remessa"));
            });
    })
};

export const obterRemessasOcorridas = (): Promise<RetornoOcorridoDTO[]> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.get(`${urls.obterRemessasOcorridas}`)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao obter remessas ocorridas"));
            });
    });
};


export const novaOcorrencia = (params: RemessaOcorrenciaDTO): Promise<boolean> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(urls.novaOcorrencia, params)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao solicitar baixa"));
            });
    })
};

export const cancelarBoleto = (boletoId: number): Promise<boolean> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.get(`${urls.cancelarBoleto}/${boletoId}`,{ params: { boletoId } })
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao cancelar boleto"));
            });
    })
};

export const alterarVencimentos = (param: BoletoAlterarVencimentos): Promise<boolean> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(urls.alterarVencimentos, param)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao alterar vencimentos"));
            });
    })
};


export interface GerarRemessaDTO {
    paramBoletoId: number;
    boletosIds: number[];
    destino: string;
    nomeUsuario: string;
    senha: string;
}

export interface RemessaFiltros {
    remessaId?: number | null;
    paramBoletoId?: number | null;
    numeroRemessa?: number | null;
    dataInicial?: string | null;
    dataFinal?: string | null;
    paginaAtual?: number | null;
    tamanhoPagina?: number | null;
}
export interface BoletoRemessa {
    remessaId: number;
    paramBoletoId: number;
    paramBoleto: object;
    dataRemessa: string;
    numeroRemessa: number;
    qtdeItens: number;
    total: number;
    arquivo: string;
    nomeArquivo: string;
    itens: BoletoRemessaItem[] | null;
}

export interface BoletoObterRemessaFiltros {
    remessaId?: number;
    nome?: string | null;
    dataVencInical?: Date | null;
    dataVencFinal?: Date | null;
    ocorrenciaId?: string | null;
    paginaAtual?: number;
    tamanhoPagina?: number;
}

export interface BoletoRemessaItem {
    id: number;
    remessaId: number;
    boletoId: number;
    ocorrenciaId: string;
    ocorrencia: BoletoOcorrencia
    remessa: BoletoRemessa | null;
    boleto: Boleto | null;
}

export interface ObterRemessaItensFiltros {
    paramBoletoId?: number | null;
    dataInicial?: string | null;
    dataFinal?: string | null;
    remessaId?: number | null;
    ocorrenciaIds?: string[] | null;
    nossoNumero?: string | null;
    clienteId?: number | null;
    nome?: string | null;
    comAcoes?: boolean;
    paginaAtual?: number | null;
    tamanhoPagina?: number | null;
}

export interface BoletoRemessaItemDTO {
    id: number;
    paramBoletoId: number;
    tipoCobranca: string;
    cedenteCodigo: string;
    remessaId: number;
    dataRemessa: string | null;
    pedidoId: number | null;
    nossoNumero: string;
    numeroDocumento: string;
    dataDocumento: string;
    dataVencimento: string | null;
    valorDocumento: number;
    valorDesconto: number;
    valorTotal: number;
    clienteId: number | null;
    clienteNome: string;
    cpfCnpj: string;
    ocorrenciaId: string | null;
    ocorrenciaDescricao: string;
    boletoId: number | null;
    observacao: string | null;
    usuarioNome: string | null;
    tipo: string;
}

export interface BoletoOcorrencia {
    ocorrenciaId: string;
    descricao: string;
    tipo: string;
}

export interface IRemessasRetorno {
    dados: Array<BoletoRemessa>,
    totalRegistros: number
}

export interface IRetornoItens {
    dados: Array<BoletoRetornoItemDTO>,
    totalRegistros: number
}


export interface RemessaOcorrenciaDTO {
    boletoId: number;
    valor: string | null;
    api: boolean;
}

export interface BoletoRelDif {
    boletoId: number;
    nossoNumero: string | null;
    numeroDocumento: string | null;
    seuNumero: string | null;
    ocorrenciaId: string | null;
    descricaoTipoOcorrencia: string | null;
    clienteId: number;
    nome: string;
    dataVencimento: string;
    dataPagamento: string;
    valorDocumento: number;
    valorMoraJuros: number;
    valorPago: number;
    valorDiferenca: number;
    valorOutrosCreditos: number;
    valorDesconto: number;
    diasAtraso: number;
    valorReceberMulta: number;
    valorReceberJuros: number;
    valorReceber: number;
}

export interface BoletoAlterarVencimentos {
    paramBoletoid: number;
    boletosIds: number[];
    novoVencimento: string;
    registrarOnLine: boolean;
}

//#endregion

//#region + Retornos 


export const importarRetorno = (params?: ImportarRetornoDTO | null | any): Promise<BoletoRetorno> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        const formData = new FormData();
        formData.append('paramBoletoId', params.paramBoletoId.toString());
        formData.append('nomeUsuario', params.nomeUsuario);
        formData.append('senha', params.senha);
        formData.append('arquivo', params.arquivo);

        axios.post(urls.importarRetorno, formData, {
            timeout: 360000, // 3 minutos (180000ms)
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao importar retorno"));
            });
    })
};

export const obterRetornos = (params: BoletoRetornosFiltros): Promise<BoletoRetornoGrid> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();


        axios.post(`${urls.obterRetornos}`, params)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao obter retornos"));
            });
    })
};

export const obterRetornoDetalhes = (filtros: ObterRetornoItensFiltros): Promise<IRetornoItens> => {
    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(`${urls.obterRetornoDetalhes}`, filtros)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao obter detalhes do retorno"));
            });
    });
};

export const obterRetornoResumo = (retornoId: number): Promise<ResumoRetornoDto> => {
    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.get(`${urls.obterRetornoResumo}/${retornoId}`, { params: { retornoId } })
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao obter resumo do retorno"));
            });
    });
};

export const processarRetorno = (retornoId: number): Promise<void> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();
        const params = { retornoId: retornoId };

        axios.get(`${urls.processarRetorno}/${retornoId}`, { params, timeout: 180000 })
            .then(r => {
                return resolve();
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao processar retorno"));
            });
    });
};

export const obterRetornoDiferencas = (retornoId: number): Promise<BoletoRelDif[]> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();
        const params = { retornoId: retornoId };

        axios.get(`${urls.obterRetornoDiferencas}?retornoId=${retornoId}`, { params })
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao obter diferenças do retorno"));
            });
    });
};

export const obterRetornosOcorridos = (): Promise<RetornoOcorridoDTO[]> => {

    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.get(`${urls.obterRetornosOcorridos}`)
            .then(r => {
                return resolve(r.data);
            })
            .catch(error => {
                return reject(new ApiException(error || "falha ao obter retornos ocorridos"));
            });
    });
};


export interface RetornoOcorridoDTO {
    ocorrenciaId: string;
    descricao: string;
    tipo: string;
}

export interface ImportarRetornoDTO {
    paramBoletoId: number;
    nomeUsuario: string;
    senha: string;
    arquivo: File;
}



export enum eBoletoRetornoStatus {
    Aguardando = 0,
    Processando = 1,
    Processado = 2,
    Erro = 3
}

export interface BoletoRetornoItemDTO {
    id: number;
    retornoId: number;
    clienteNome: string;
    cpfCnpj: string;
    dataVencimento: string | null;
    nossoNumero: string;
    numeroDocumento: string;
    valorDocumento: number;
    dataOcorrencia: string;
    dataCredito: string;
    dataBaixa: string | null;
    valorPago: number;
    valorRecebido: number;
    codTipoOcorrencia: string;
    ocorrenciaDescricao: string;
    motivosRejeicao: string;
    motivoRejeicaoComandos: string;
    liquidadoBanco: number;
    boletoId: number | null;
    boletoStatus: string | null;
    clienteId: number | null;
    ocorrenciaId: string | null;
    valorMoraJuros: number;
    valorDescontos: number;
    valorDespesasCobranca: number;
    valorIOF: number;
    valorOutrasDespesas: number;
    valorOutrosCreditos: number;
    statusProcessamento: string | null;
}


export interface BoletoRetornosFiltros {
    paramBoletoId?: number | null;
    dataCadIni?: string | null;
    dataCadFin?: string | null;
    retornoId?: number | null;
    status?: eBoletoRetornoStatus | null;
    paginaAtual?: number ;
    tamanhoPagina?: number;
}

export interface ObterRetornoItensFiltros {
    paramBoletoId?: number | null;
    dataInicial?: string | null;
    dataFinal?: string | null;
    retornoId?: number | null;
    ocorrenciaIds?: string[] | null;
    nossoNumero?: string | null;
    statusProcessamento?: string | null;
    nome?: string | null;
    paginaAtual?: number | null;
    tamanhoPagina?: number | null;
}

export interface BoletoRetornoGrid {
    dados: Array<BoletoRetorno>,
    totalRegistros: number
}

export interface BoletoRetorno {
    retornoId: number;
    paramBoletoId: number;
    cedenteCodigo: string;
    cedenteCpfCnpj: string;
    qtdeItens: number;
    arquivo: string | null;
    status: eBoletoRetornoStatus;
    numero: number;
    numeroCorrespondente: number;
    versaoArquivo: number;
    versaoLote: number;
    numeroArquivo: number;
    dataCadastro: Date;
}

export interface ResumoRetornoDto {
    retorno: BoletoRetorno;
    resumoPorOcorrencia: RetornoPorOcorrenciaDto[];
    resumoPorStatus: RetornoPorStatusDto[];
}

export interface RetornoPorOcorrenciaDto {
    ocorrenciaId: string;
    descricao: string;
    qtde: number;
    valorDocumento: number;
    valorMoraJuros: number;
    valorDespesasCobranca: number;
    valorIOF: number;
    valorOutrosCreditos: number;
    valorOutrasDespesas: number;
    valorDescontos: number;
    valorRecebido: number;
}

export interface RetornoPorStatusDto {
    ocorrenciaId: string;
    statusProcessamento: string;
    qtde: number;
    valorDocumento: number;
}




//#endregion


export const importarRelatorioBanco = (arquivo: File): Promise<ImpRelBancoItemDTO[]> => {
    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        const formData = new FormData();
        formData.append('arquivo', arquivo);

        axios.post(urls.importarRelBanco, formData, {
            timeout: 360000, // 3 minutos
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        .then(r => {
            return resolve(r.data);
        })
        .catch(error => {
            return reject(new ApiException(error || "Falha ao importar relatório do banco"));
        });
    });
};

export const aplicarRelatorioBanco = (itens: ImpRelBancoAplicarDTO[]): Promise<string[]> => {
    return new Promise((resolve, reject) => {

        axios.defaults.headers.common.Authorization = getToken();

        axios.post(urls.aplicarRelBanco, itens)
        .then(r => {
            return resolve(r.data);
        })
        .catch(error => {
            return reject(new ApiException(error || "Falha ao aplicar o relatório do banco"));
        });
    });
};

export interface ImpRelBancoItemDTO {
    tipo: string; // "Vencidos" | "Liquidados" | "Baixados"
    seuNumero: string | null;
    nossoNumero: string;
    pagador: string | null;
    valor: number;
    dataVencimento: string | null;
    dataLiquidacao: string | null;
    valorCobrado: number | null;
    dataBaixa: string | null;

    boletoId: number | null;
    clienteId: number | null;
    mensalidadeId: number | null;
    statusAtualId: number;
    statusAtualDescricao: string | null;

    acaoProposta: string | null;
    podeAplicar: boolean;
}

export interface ImpRelBancoAplicarDTO {
    boletoId: number;
    tipo: string;
    valor: number;
    valorCobrado: number | null;
    dataLiquidacao: string | null;
}